import type { ThemeId } from '../contracts/registry'

type ThemeTokens = {
  palette: { bg: string; fg: string; muted: string; accent_default: string }
  fonts: { heading: string; body: string }
}

export const themes: Record<ThemeId, ThemeTokens> = {
  editorial: {
    palette: {
      bg: '#faf7f2',
      fg: '#1f1b15',
      muted: '#8a7e6e',
      accent_default: '#7b8b6f',
    },
    fonts: {
      heading: "'Cormorant Garamond', serif",
      body: "'Inter', system-ui, sans-serif",
    },
  },
  minimal: {
    palette: {
      bg: '#ffffff',
      fg: '#111111',
      muted: '#666666',
      accent_default: '#111111',
    },
    fonts: {
      heading: "'Inter', system-ui, sans-serif",
      body: "'Inter', system-ui, sans-serif",
    },
  },
  playful: {
    palette: {
      bg: '#fff7fb',
      fg: '#1f1b15',
      muted: '#7c6a7c',
      accent_default: '#d35d90',
    },
    fonts: {
      heading: "'Nunito', system-ui, sans-serif",
      body: "'Inter', system-ui, sans-serif",
    },
  },
}
